import { Feature, NavLink, SocialLink, Property, FAQItem, Step } from './types'

// ========================================
// NAVIGATION
// ========================================
export const NAV_LINKS: NavLink[] = [
  { id: 'proyectos', label: 'Proyectos', href: '#proyectos' },
  { id: 'beneficios', label: 'Beneficios', href: '#beneficios' },
  { id: 'faq', label: 'FAQ', href: '#faq' },
  { id: 'contacto', label: 'Contacto', href: '#contacto' },
]

// ========================================
// COMPANY INFORMATION
// ========================================
export const COMPANY_INFO = {
  name: 'Bavarian Real Estate',
  tagline: 'Asesoría inmobiliaria e inversión en República Dominicana',
  email: 'realestate@grupobavarian.com',
  phone: '+1 (809) 480-4278',
  phoneHref: '+18094804278',
  address: 'República Dominicana',
  calendlyLink: '[CALENDLY_LINK]',
  leadDestination: 'realestate@grupobavarian.com',
}

// ========================================
// TRUST / DIFFERENTIALS (4 Cards)
// ========================================
export const TRUST_FEATURES: Feature[] = [
  {
    id: '1',
    title: 'Transparencia',
    description: 'Información clara para decidir bien.',
    icon: 'shield',
  },
  {
    id: '2',
    title: 'Selección exigente',
    description: 'Proyectos con potencial real.',
    icon: 'star',
  },
  {
    id: '3',
    title: 'Eficiencia',
    description: 'Respuesta rápida y guía directa.',
    icon: 'zap',
  },
  {
    id: '4',
    title: 'Acompañamiento',
    description: 'Asesoría humana y personalizada.',
    icon: 'users',
  },
]

// ========================================
// PROPERTIES (Featured Projects - Order: Forest, Tareya, Orión)
// ========================================
export const PROPERTIES: Property[] = [
  {
    id: '1',
    name: 'FOREST Punta Cana',
    location: 'Punta Cana',
    priceFrom: '100,982',
    reserve: '2,000',
    amenities: [
      'Piscinas',
      'Gimnasio equipado',
      'Cancha de pádel',
      'Parque infantil',
      'Plaza comercial',
      'Área BBQ',
      'Área social / Bar',
      'Beach Club (vía acuerdo estratégico)',
      'Cancha de basketball',
      'Pet Park',
      'Clubhouse / Casa club (restaurante, BBQ, salón multipropósito)',
    ],
    apartmentTypes: [
      '2 habitaciones (3 layouts)',
      'Primer nivel con patio / backyard',
      'Niveles 2-3 con balcón',
      'Penthouse con rooftop terrace privado',
    ],
    bathrooms: ['2 baños (en tipologías de 2 habitaciones)'],
    image: '/assets/FOREST_BAV.jpeg',
  },
  {
    id: '3',
    name: 'ORIÓN Punta Cana Residences',
    location: 'Costa Bávaro, Punta Cana',
    priceFrom: '139,000',
    reserve: '5,000',
    amenities: ['Rooftop con piscina', 'Área BBQ', 'Zona de tumbonas', 'Gimnasio equipado'],
    apartmentTypes: [
      'Apartamentos y penthouses de 1 y 2 habitaciones',
      'Opción con Rooftop Terrace (según tipología)',
    ],
    bathrooms: ['1 habitación: 1 baño', '2 habitaciones: 2 baños'],
    parking: ['Garaje cubierto en semi-sótano (29 plazas)', 'Parqueos exteriores para visitantes'],
    image: '/assets/ORION_BAV.jpg',
  },
]

// ========================================
// HOW IT WORKS (3 Steps)
// ========================================
export const HOW_IT_WORKS_STEPS: Step[] = [
  {
    id: '1',
    number: '01',
    title: 'Dinos tu objetivo',
    description: 'Inversión, renta vacacional o uso personal.',
  },
  {
    id: '2',
    number: '02',
    title: 'Te enviamos opciones reales',
    description: 'Proyectos y unidades según presupuesto y zona.',
  },
  {
    id: '3',
    number: '03',
    title: 'Agendas llamada y avanzas con guía',
    description: 'Te acompañamos desde la reserva hasta la entrega.',
  },
]

// ========================================
// FAQ (Accordion Items)
// ========================================
export const FAQ_ITEMS: FAQItem[] = [
  {
    id: '1',
    question: '¿Puedo comprar desde el extranjero?',
    answer:
      'Sí. El proceso puede realizarse a distancia con acompañamiento, envío de información y coordinación para firma según el proyecto y el comprador.',
  },
  {
    id: '2',
    question: '¿Qué necesito para reservar una unidad?',
    answer:
      'Generalmente se requiere una reserva inicial y documentación básica. Los montos y pasos varían según el proyecto.',
  },
  {
    id: '3',
    question: '¿Cómo sé qué proyecto me conviene?',
    answer:
      'Te orientamos según tu objetivo (inversión, renta o uso), presupuesto, plazo y zona de preferencia.',
  },
  {
    id: '4',
    question: '¿Qué zonas recomiendan para inversión?',
    answer:
      'Depende del perfil del comprador. Usualmente se priorizan destinos con alta demanda turística o crecimiento residencial.',
  },
  {
    id: '5',
    question: '¿Puedo generar ingresos por renta vacacional?',
    answer:
      'En proyectos orientados a renta, sí. La rentabilidad depende de ubicación, amenidades, estacionalidad y estrategia de gestión.',
  },
  {
    id: '6',
    question: '¿Incluyen asesoría durante todo el proceso?',
    answer:
      'Sí. Acompañamos desde la selección hasta la entrega, incluyendo coordinación y seguimiento.',
  },
  {
    id: '7',
    question: '¿Los precios "desde" cambian?',
    answer:
      'Sí. Los precios y disponibilidad pueden variar por etapa del proyecto, inventario y condiciones comerciales.',
  },
  {
    id: '8',
    question: '¿Qué beneficios fiscales aplican?',
    answer:
      'Algunos proyectos pueden aplicar a incentivos (ej. CONFOTUR). Se confirma según el proyecto y su estatus/condiciones vigentes.',
  },
  {
    id: '9',
    question: '¿Hay opciones de financiamiento o planes de pago?',
    answer:
      'Muchos proyectos ofrecen planes por etapas. Se valida en llamada según el proyecto y perfil.',
  },
  {
    id: '10',
    question: '¿Cuánto tarda el proceso de compra?',
    answer:
      'Depende del proyecto (en construcción o entrega inmediata) y de tu rapidez de decisión/documentación. En llamada te damos ruta clara.',
  },
]

// ========================================
// SOCIAL LINKS
// ========================================
export const SOCIAL_LINKS: SocialLink[] = [
  {
    platform: 'Instagram',
    url: 'https://www.instagram.com/bavarian.realestate/?hl=es',
    icon: 'instagram',
  },
  {
    platform: 'LinkedIn',
    url: 'https://linkedin.com/company/bavarianrealestate',
    icon: 'linkedin',
  },
  {
    platform: 'Facebook',
    url: 'https://www.facebook.com/profile.php?id=61584859374087',
    icon: 'facebook',
  },
]

// ========================================
// WHATSAPP CONFIGURATION
// ========================================
export const WHATSAPP_CONFIG = {
  phoneNumber: '18094804278',
  message:
    'Hola, me interesa obtener información sobre los proyectos de inversión en República Dominicana.',
  label: 'Contactar por WhatsApp',
}

// ========================================
// THANK YOU PAGE
// ========================================
export const THANK_YOU_CONTENT = {
  eyebrow: 'Solicitud recibida',
  headline: '¡Gracias por contactarnos!',
  message:
    'Recibimos tu información. Un asesor de Bavarian Real Estate te contactará pronto con opciones alineadas a tu presupuesto y objetivo.',
  nextStepsTitle: 'Qué pasa ahora',
  nextSteps: [
    'Revisaremos tu presupuesto y objetivo de inversión.',
    'Te enviaremos opciones disponibles y precios actualizados.',
    'Coordinaremos una llamada para resolver dudas y próximos pasos.',
  ],
  whatsappLabel: 'Escribir por WhatsApp',
  homeLabel: 'Volver al inicio',
  calendarLabel: 'Agendar llamada',
}

// ========================================
// IMAGES
// ========================================
export const IMAGES = {
  hero: '/assets/hero_bavarian.jpeg',
  logo: '/assets/bavarian-logo-black.png',
  logoWhite: '/assets/bavarian-logo-white.png',
  ogImage: '/assets/hero_bavarian.jpeg',
}

// ========================================
// HERO CONTENT
// ========================================
export const HERO_CONTENT = {
  headline: 'Invierte en República Dominicana con proyectos seleccionados y acompañamiento real.',
  subheadline:
    'Accede a oportunidades en destinos de alta demanda con ubicación estratégica, diseño funcional y potencial de valorización. Te guiamos en cada paso: desde la elección hasta la entrega.',
  bullets: [
    'Proyectos en zonas clave del Caribe',
    'Enfoque en inversión y plusvalía',
    'Asesoría clara, rápida y personalizada',
  ],
  ctaPrimary: 'Agendar llamada',
  ctaSecondary: 'Solicitar información',
}
